/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Listing_Extra_Info_PushedInputs */

const cs_portals_listing_extra_info_pushed = /** @type {(inputs: Portals_Listing_Extra_Info_PushedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav nabídky uložen a odeslán na Sreality`)
};

const en_portals_listing_extra_info_pushed = /** @type {(inputs: Portals_Listing_Extra_Info_PushedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal listing status saved and pushed to Sreality`)
};

/**
* | output |
* | --- |
* | "Portal listing status saved and pushed to Sreality" |
*
* @param {Portals_Listing_Extra_Info_PushedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_listing_extra_info_pushed = /** @type {((inputs?: Portals_Listing_Extra_Info_PushedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Listing_Extra_Info_PushedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_listing_extra_info_pushed(inputs)
	return cs_portals_listing_extra_info_pushed(inputs)
});